import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {BlockService} from '../../service/BlockService';
import {UserService} from '../../service/UserService';
import {EmitterService} from '../../service/EmitterService';
import {MatSort, MatTableDataSource, MatPaginator, MatDialog, MatCheckboxChange} from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DATE_DEFAULT_FORMAT } from '../../model/commons/DateConstants';
import { TimeZoneService } from '../../service/TimeZoneService';
import { OpenFicheService } from '../../service/open-fiche.service';
import { LoggerService } from '../../service/LoggerService';
import { _ } from 'underscore';
import {
  DATE_FICHE_LABEL,
  DATE_DEMANDE_LABEL,
  IS_PORTUGAL
} from '../../helpers/GlobalConstants';
import { MessageService } from '../../service/message.service';
import { ObjectNotificationService } from '../../service/obj-notification.service';
import { ValidateDemandeDialogComponent } from '../block-temps/validate-demande-dialog/validate-demande-dialog.component';

@Component({
  selector: 'app-reopen-requests-process',
  templateUrl: './reopen-requests-process.component.html',
  styleUrls: ['./reopen-requests-process.component.css']
})
export class ReopenRequestsProcessComponent implements OnInit, AfterViewInit {
  displayedColumns = ['select','demandeur', 'agent', DATE_FICHE_LABEL, DATE_DEMANDE_LABEL, 'motif', 'action'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource();
  data;
  @ViewChild(MatSort) sort: MatSort;

  public Display = {
    row: ['Réalisé validé'],
    breaks: false,
    header: true,
    paginator: false,
    buttons: {
      valider: false,
      claim: false
    },
    styles: {
      margin: {top: -10, right: 40, bottom: 20, left: 100},
      height: '100px'
    },
    dialog: false
  };
  searchRequest = new FormGroup({
    agent: new FormControl(''),
    status: new FormControl(''),
    demandeur: new FormControl(''),
    dateDebutFiche: new FormControl(''),
    dateFinFiche: new FormControl(''),
    dateDebutDemande: new FormControl(''),
    dateFinDemande: new FormControl('')
  })
  loading = false;
  basicDataSource: any;
  constructor(public router: Router,
              public   activatedRoute: ActivatedRoute,
              private blockservice: BlockService,
              private messageService: MessageService,
              private user: UserService,
              private emit: EmitterService,
              private tzService: TimeZoneService,
              public dialog: MatDialog,
              private openFicheService: OpenFicheService,
              private LOG: LoggerService,
              private objNotificationService: ObjectNotificationService) {


        // console.log(23, 26, this.tzService.getReopenFichePeriod(23, 26));
        // console.log(2, 14, this.tzService.getReopenFichePeriod(2, 14));
        // console.log(6, 2, this.tzService.getReopenFichePeriod(6, 2));

  }

  ngOnInit() {
    this.loading = true;
    this.selected3 = [];
    this.isChecked();
    const isPorgugal: boolean  = localStorage.getItem(IS_PORTUGAL) == 'Y';
    const url = this.activatedRoute.snapshot.url[0].path;
    this.openFicheService.getRequestsToValidate(isPorgugal).subscribe(res => {
      this.basicDataSource = [...res.filter(m=> m.status == "PENDING")];
      this.applyFilter();
      this.loading = false;
    })
    this.messageService.getMessage().subscribe(msg => {
      this.loading = msg && msg.text == 'LOADING'
    })
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  formatDate(date: string){
    return moment(date).format(DATE_DEFAULT_FORMAT)
  }


  applyFilter() {
    console.log("filter ");
    this.dataSource.data = [...this.basicDataSource];
     // MatTableDataSource defaults to lowercase matches
    let mapValues = Object.entries(this.searchRequest.controls).filter(control => control[1].value).map(entry => {
      return {
        key: entry[0],
        entry: entry[1].value
      }
    });
    if (mapValues.filter(m=> m.key == "status" && m.entry<=0).length>0)
      mapValues = mapValues.filter(m=> m.key != "status");

    if(mapValues && mapValues.length > 0)
      this.dataSource.data = this.blockservice.filterData(mapValues,this.dataSource.data);
  }

  sendData(element){
    this.objNotificationService.sendObject(element);
  }

  validateDemande(id,ids?){
    const dialogRef = this.dialog.open(ValidateDemandeDialogComponent, {
      width: '300px !important',
      height: '100px !important',
      panelClass: 'ConfirmationDialog',
      data: {
        from: 'validate',
        id: id,
        ids: ids?ids:null,
        callback: ids? (ids) => this.openFicheService.validateRequestList(ids)
              : (id) => this.openFicheService.validateRequest(id)
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if(res) this.ngOnInit();
      this.messageService.clearMessages();
      this.objNotificationService.sendObject({hrbpNotificationUpdate: true});
    })
  }
  rejectDemande(id,ids?){
    const dialogRef = this.dialog.open(ValidateDemandeDialogComponent, {
      width: '300px !important',
      height: '100px !important',
      panelClass: 'ConfirmationDialog',
      data: {
        from: 'reject',
        id: id,
        ids: ids?ids:null,
        callback: ids? (ids) => this.openFicheService.rejectRequestList(ids)
            : (id) => this.openFicheService.rejectRequest(id)
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if(res) this.ngOnInit();
      this.messageService.clearMessages();
      this.objNotificationService.sendObject({hrbpNotificationUpdate: true});
    })
  }

  reset(){
    this.ngOnInit();
  }

  selected3:any[] = [];
  toggle(item,event: MatCheckboxChange) {
    if (event.checked) {
      this.selected3.push(item);
    } else {
      const index = this.selected3.indexOf(item);
      if (index >= 0) {
        this.selected3.splice(index, 1);
      }
    }
    console.log(item + "<>", event.checked);
  }

  exists(item) {
    return this.selected3.indexOf(item) > -1;
  };

  isIndeterminate() {
    return (this.selected3.length > 0 && !this.isChecked());
  };

  isChecked() {
    return this.dataSource.data.length == 0?false:this.selected3.length === this.dataSource.data.length;
  };

  toggleAll(event: MatCheckboxChange) {

    if ( event.checked ) {
      this.selected3 = [];
      this.dataSource.data.forEach(row => {
        this.selected3.push(row)
      });
    } else {
      this.selected3.length = 0;
    }
  }

  get lengthSelected() {
    return this.selected3.length;
  }

  get totalRows() {
    return this.dataSource.data.length;
  }
  _send: false;
  valid(){
    let ids = this.selected3.map(s=> s.id);
    this.validateDemande(null,ids);
  }

  rejected() {
    let ids = this.selected3.map(s=> s.id);
    this.rejectDemande(null,ids);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/reopen-requests-process/reopen-requests-process.component.ts